type ListCardProps = {
    children: React.ReactNode
}

const ListCardGroup = (props: ListCardProps) => {
    const { children } = props
    return <div className="space-y-4">{children}</div>
}

export default ListCardGroup
